import React from "react";
import "./Why_Choose_Us.css";
import Common_Title from "../../common_component/common_title/Common_Title";

const WhyChooseUs = () => {
  const data = [
    {
      icon: "/assets/images/about-us/why-choose-us/personalize_planning.png",
      title: "Personalized Planning",
      description:
        "Every trip is carefully designed to match your needs & preferences.",
    },
    {
      icon: "/assets/images/about-us/why-choose-us/end-to-end-support.png",
      title: "End-to-End Support",
      description:
        "From booking to return, our team stays with you throughout your journey.",
    },
    {
      icon: "/assets/images/about-us/why-choose-us/trusted-travel.png",
      title: "Trusted Travel Experts",
      description:
        "Experienced professionals ensuring smooth, safe, and stress-free travel.",
    },
    {
      icon: "/assets/images/about-us/why-choose-us/transparent.png",
      title: "Transparent & Fair Pricing",
      description: "No hidden costs clear, honest, and competitive pricing.",
    },
    {
      icon: "/assets/images/about-us/why-choose-us/assistance.png",
      title: "24/7 Assistance",
      description:
        "Always available for guidance, support, & quick solutions while you travel.",
    },
  ];

  return (
    <section className="why-choose-section">
      <div className="container">
        <div className="head">
          <div className="title_why_choose_us">
            <Common_Title title="Why Choose Us" />
          </div>
        </div>

        <div className="row justify-content-center">
          {data.map((item, index) => (
            <div
              key={index}
              className="col-lg-4 col-md-6 mb-4 col-sm-6 d-flex justify-content-center"
            >
              <div className="why-card">
                <img src={item?.icon} alt={item?.title} className="why-icon" />

                <h5>{item?.title}</h5>

                <p>{item?.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
